export default class SearchParams {
  constructor({
    placeType,
    shortName,
    longName,
    themes,
    activities,
    ambiances,
    transports,
    travellers,
    seasons,
    media,
    radius,
    longitude,
    latitude,
    page,
    xMin,
    xMax,
    yMin,
    yMax,
    username
  } = {}) {
    this.longitude = parseFloat(longitude) || NaN;
    this.latitude = parseFloat(latitude) || NaN;
    this.clientLongitude = sessionStorage.getItem("clientLongitude");
    this.clientLatitude = sessionStorage.getItem("clientLatitude");
    this.placeType = placeType || "country";
    this.shortName = shortName || "";
    this.longName = longName || "";
    this.radius = parseInt(radius) || NaN;
    this.bbox = [
      parseFloat(xMin) || -5.009766,
      parseFloat(yMin) || 41.211722,
      parseFloat(xMax) || 9.887695,
      parseFloat(yMax) || 51.151786
    ];

    this.themes = themes || [];
    this.activities = activities || [];
    this.ambiances = ambiances || [];
    this.transports = transports || [];
    this.travellers = travellers || [];
    this.seasons = seasons || [];
    this.page = parseInt(page) || 1;
    this.username = username || "";
    this.media = media || [];
  }
  isFiltersActivated() {
    return (
      this.activities.length > 0 ||
      this.ambiances.length > 0 ||
      this.transports.length > 0 ||
      this.travellers.length > 0 ||
      this.seasons.length > 0 ||
      this.media.length > 0
    );
  }
  getLocationDataForDestinationAutocomplete() {
    return {
      shortName: this.shortName,
      placeType: this.placeType,
      longName: this.longName
    };
  }
  getDataForNewSearch() {
    let coordinates = [];
    if (
      /range|bbox|myPosition|department|region|administrative|country/.test(
        this.placeType
      ) &&
      this.clientLatitude &&
      this.clientLongitude
    ) {
      coordinates = [this.clientLongitude, this.clientLatitude];
    }
    if (/city|poi|locality|place|neighborhood|address/.test(this.placeType)) {
      coordinates = [this.longitude, this.latitude];
    }
    return {
      page: this.page,
      username: this.username,
      placeType: this.placeType,
      coordinates: coordinates,
      longName: this.longName,
      latitude: this.latitude,
      radius: this.radius,
      media: this.media.map(x => x.nameEn),
      seasons: this.seasons.map(x => x.nameEn),
      themes: []
        .concat(
          this.activities,
          this.ambiances,
          this.transports,
          this.travellers
        )
        .map(x => x.nameEn),
      xMin: this.bbox[0],
      xMax: this.bbox[2],
      yMin: this.bbox[1],
      yMax: this.bbox[3]
    };
  }
}
